// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3gwG_","error":"Textarea_error__KSOKv","readonly":"Textarea_readonly__2qo0-","disabled":"Textarea_disabled__1DTVH"};